import React, { Component } from 'react';
import { compose } from 'redux';
import cn from 'classnames';
import PropTypes from 'prop-types';
import injectSheet from './styleWaitlistBanner';
import connect from './connectWaitlistBanner';
import ImageOrVideo from '../ImageOrVideo';

import {
  responsiveImageType,
  responsiveVideoType,
} from '../../propTypes';
import FullViewportContainer from '../FullViewportContainer';
import Countdown from '../Countdown';
import ContentContainer from '../Header/ContentContainer';
import Title from '../Title';
import WaitlistForm from './WaitlistForm';
import formatDateTime from '../../helpers/formatDateTime';
import createElementResizeDetectorRef from '../../helpers/createElementResizeDetectorRef';
import Overlay from './Overlay';

class WaitlistBanner extends Component {
  state = { minHeight: undefined };

  componentDidUpdate() {
    this.updateMinHeight();
  }

  setRef = createElementResizeDetectorRef(() => {
    this.updateMinHeight();
  });

  setCaptionRef = ref => { this.captionRef = ref; };

  getWrapperClass = () => {
    const {
      classes, isDark, formVisible,
    } = this.props;
    return cn(
      classes.root,
      !formVisible && isDark.mobile && classes.darkWrapper,
      (formVisible || !isDark.mobile) && classes.lightWrapper,
      isDark.desktop && classes.desktopDarkWrapper,
      !isDark.desktop && classes.desktopLightWrapper,
    );
  };

  updateMinHeight = () => {
    const { minHeight } = this.state;
    if (this.captionRef) {
      const inlineContainer = this.captionRef;
      const { height } = inlineContainer.getBoundingClientRect();
      if (height !== minHeight) {
        this.setState({ minHeight: height });
      }
    }
  };

  renderOverlay = () => {
    const { formVisible, toggleVisibility, sliceId } = this.props;
    return <Overlay show={formVisible} onCloseClick={() => toggleVisibility(sliceId)} />;
  };

  renderTitle = () => {
    const {
      classes, title, titleTag, countdownUntil,
    } = this.props;
    return (
      <Title className={classes.title} tag={titleTag}>
        {title}
        {countdownUntil && (
          <span>
            {formatDateTime(new Date(countdownUntil))}
          </span>
        )}
      </Title>
    );
  };

  renderCountdown = () => {
    const {
      classes, sliceId, hasActiveCountdown, formVisible,
    } = this.props;
    return hasActiveCountdown && (
      <Countdown
        className={cn(classes.countdown, { formVisible })}
        sliceId={sliceId}
        animated
      />
    );
  };

  renderForm = () => {
    const { sliceId } = this.props;
    return <WaitlistForm sliceId={sliceId} />;
  };

  renderContentContainer = () => {
    const {
      classes, alignment, position, edgeToEdge, showSignupForm,
    } = this.props;
    return (
      <ContentContainer
        alignment={alignment}
        className={classes.content}
        edgeToEdge={edgeToEdge}
        position={position}
        largeContent
      >
        <div className={cn(classes.caption)} ref={this.setCaptionRef}>
          <div className={cn({ [classes.countdownContainer]: showSignupForm })}>
            {this.renderTitle()}
            {this.renderCountdown()}
          </div>
          {showSignupForm && this.renderForm()}
        </div>
      </ContentContainer>
    );
  };

  render() {
    const {
      classes, image, video,
    } = this.props;
    const { minHeight } = this.state;

    const wrapperClassName = this.getWrapperClass();

    return (
      <FullViewportContainer>
        <div
          className={wrapperClassName}
          ref={this.setRef}
          style={{ minHeight: minHeight && `calc(${minHeight}px + 120px)` }}
        >
          <ImageOrVideo
            className={classes.image}
            imageClassName={classes.image}
            image={image}
            video={video}
          />
          {this.renderOverlay()}
          {this.renderContentContainer()}
        </div>
      </FullViewportContainer>
    );
  }
}

WaitlistBanner.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  sliceId: PropTypes.number.isRequired,
  image: responsiveImageType,
  video: responsiveVideoType,
  hasActiveCountdown: PropTypes.bool.isRequired,
  alignment: PropTypes.shape({
    desktop: PropTypes.string.isRequired,
    mobile: PropTypes.string.isRequired,
  }).isRequired,
  position: PropTypes.shape({
    desktop: PropTypes.string.isRequired,
    mobile: PropTypes.string.isRequired,
  }).isRequired,
  edgeToEdge: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  titleTag: PropTypes.string,
  isDark: PropTypes.shape({
    desktop: PropTypes.bool.isRequired,
    mobile: PropTypes.bool.isRequired,
  }).isRequired,
  countdownUntil: PropTypes.number,
  formVisible: PropTypes.bool,
  toggleVisibility: PropTypes.func.isRequired,
  showSignupForm: PropTypes.bool.isRequired,
};

WaitlistBanner.defaultProps = {
  image: undefined,
  video: undefined,
  titleTag: 'h2',
  countdownUntil: undefined,
  formVisible: false,
};

export default compose(connect, injectSheet)(WaitlistBanner);
